import { render, staticRenderFns } from "./mainApp.vue?vue&type=template&id=03862a72&scoped=true"
import script from "./mainApp.vue?vue&type=script&lang=js"
export * from "./mainApp.vue?vue&type=script&lang=js"
import style0 from "./mainApp.vue?vue&type=style&index=0&id=03862a72&prod&lang=css"
import style1 from "./mainApp.vue?vue&type=style&index=1&id=03862a72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03862a72",
  null
  
)

export default component.exports